import React from 'react';
import Container from '../Container';
import BuildRelationshipsGraphic from '../svg/BuildRelationshipsGraphic';

const BuildRelationshipsSection = () => (
  <section className="bg-sp-primary-bright py-6">
    <Container className="py-12">
      <div className="flex flex-col lg:flex-row items-center">
        <div className="max-w-[40rem] lg:mr-auto pb-10 mb-9 lg:mb-0">
          <p className="mt-4 text-4xl tracking-wide font-light text-white text-center lg:text-left">
            Build Sustainable Relationships With Your Best Customers
          </p>
        </div>
        <div>
          <BuildRelationshipsGraphic className="w-full" />
        </div>
      </div>
    </Container>
  </section>
);

export default BuildRelationshipsSection;
